<form #form="ngForm"
      method="POST"
      class="block"
      [class.m-t]="complexOptions?.length">

    @for(complexOption of complexOptions; track complexOption.option.data.id){
    <p><span class="s2">{{complexOption.option.data.title}}:</span>&nbsp;<span
              class="p2">{{getSelectedLabel(complexOption.option)}}</span></p>
    @for(group of complexOption.groups; track group.id){

    <div class=" m-t-2"
         [class]="allowedOptions().length ? '' : 'bg-col-52 b-a b-col-5'"
         [style]="allowedOptions().length ? '' : 'border-radius: 12px; box-shadow: 0px 0px 18px 0px #00000014 inset;'">
        @if(group.title){
        <div class="p2 p-a-2 b-b b-col-5">
            {{group.title}}
        </div>
        }
        @if(isSM){
        <div class="p-a-2 overflow-hidden">
            <carousel class="default-swiper swiper-slide-per-view product-view-custom-options-complex-swiper"
                      style="overflow: visible;"
                      [slidesPerView]="'auto'"
                      [scrollbar]="{ draggable: true }"
                      [freeMode]="true"
                      [style.--pc-slides-ceil]="pcSlidesCeil"
                      [style.--pc-slides]="pcSlides"
                      [style.--pc-gutter]="'16px'"
                      imageViewRoot>
                @for(value of group.values; track value.value) {
                <ng-template carouselSlide>
                    <button type="button"
                            class="w-12"
                            (click)="select(complexOption.option, value)">
                        <span class="flex-column w-12">
                            <product-view-swatch [zoom]="true"
                                                 [forcedImage]="value.image || value.swatch"
                                                 [selected]="complexOption.option.value === value.value"
                                                 [title]="value.title">
                            </product-view-swatch>
                            <span class="m-t-1 w-12 center p2">
                                {{value.title}}
                            </span>
                        </span>
                    </button>
                </ng-template>
                }
            </carousel>

        </div>
        } @else {

        <div [grid]="5"
             style="max-height: 171px; height: auto; overflow: auto"
             class="custom-scrollbar p-r-7 p-a-2"
             [gridColumnGap]="'16px'"
             [gridRowGap]="'8px'">
            @for(value of group.values; track value.value) {
            <button type="button"
                    class="flex w-12"
                    [gridColumn]="1"
                    (click)="select(complexOption.option, value)">
                <span class="flex-column w-12">
                    <product-view-swatch [zoom]="true"
                                         [forcedImage]="value.image || value.swatch"
                                         [selected]="complexOption.option.value === value.value"
                                         [subtitle]="fabricStyle ? (fabricStyle | optionLabel : 'fabric_style') + '' : undefined"
                                         [title]="value.title">
                    </product-view-swatch>
                    <span class="m-t-1 w-12 center p2">
                        {{value.title}}
                    </span>
                </span>
            </button>
            }
        </div>
        }
    </div>
    }
    }


    <!-- @for (option of options; track option.data.id) {
    <div>
        @switch (option.type) {
        @case ('dropdown') {
        <form-field [label]="option.data.title"
                    class="block m-t-6">
            <select [name]="'option_' + option.data.id"
                    [required]="option.data.req"
                    [(ngModel)]="option.value"
                    autocomplete="off">
                <option [value]=""></option>
                @for (selection of option.values; track selection.value) {
                <option [value]="selection.value">
                    {{selection.title}}
                    @if(selection.price) {
                    - <price [value]="selection.price"></price>
                    }
                </option>
                }
            </select>
        </form-field>
        }
        @case ('radio') {
        <form-field [label]="option.data.title"
                    class="block m-t-6">
            <radio-group [name]="'option_' + option.data.id"
                         [(model)]="option.value"
                         [required]="option.data.req">
                @for (selection of option.values; track selection.value) {
                <radio-group-item [value]="selection.value">
                    {{selection.title}}
                    @if(selection.price) {
                    - <price [value]="selection.price"></price>
                    }
                </radio-group-item>
                }
            </radio-group>
        </form-field>
        }
        }
    </div>
    } -->
</form>